<template>
  <div id="app">
    <div class="menu" v-if="menuOpen">
      <a class="btn btn--round menuCloseBtn" @click="menuOpen = false">
        <img src="close-icon.svg" alt class="btn__icon" />
      </a>
      <ul class="menuItems">
        <li>
          <a href class="green" v-scroll-to="'#home'">Back to base</a>
        </li>
        <li>
          <a href v-scroll-to="'#whatwedo'">What we do</a>
        </li>
        <li>
          <a href v-scroll-to="'#ambition'">Our mission</a>
        </li>
        <li>
          <a href v-scroll-to="'#work'">Who we work for</a>
        </li>
        <li>
          <a href v-scroll-to="'#proud'">Our brands</a>
        </li>
        <li>
          <a href v-scroll-to="'#chat'">Let's chat</a>
        </li>
      </ul>
    </div>
    <header class="header" id="home" v-in-viewport>
      <div class="header__topBar">
        <a href="#" class="logo">
          <img src="pow_logo.png" alt="KAPOW" />
        </a>
        <a class="btn btn--round menuBtn" @click="menuOpen = true">
          <img src="menu-icon.svg" alt class="btn__icon" />
        </a>
      </div>
      <h1 class="primaryTitle animateUp" v-in-viewport>
        <span>Hello,</span>&nbsp;
        <span>we</span>&nbsp;
        <span>are</span>&nbsp;
        <span>Pow Comms</span>
      </h1>
      <div class="header__cta">
        <div class="caption">We do comms.</div>
        <a class="btn see-btn" v-scroll-to="'#whatwedo'">Come and have a look</a>
      </div>
    </header>
    <div class="section whatwedo" id="whatwedo" v-if="!showPrivacy">
      <p class="text--big animateUp" v-in-viewport>
        <span>We do comms</span>
        <br />
        <span>Public Relations</span>
        <br />
        <span>Copy</span>
        <br />
        <span>Packaging</span>
        <br />
        <span>and</span>
        <br />
        <span>Social Media Management</span>
      </p>
    </div>
    <div class="section ambition" id="ambition" v-in-viewport v-if="!showPrivacy">
      <p class="text--big animateUp" v-in-viewport>
        <span>It’s</span>&nbsp;
        <span>our</span>&nbsp;
        <span>ambition</span>&nbsp;
        <span>to</span>&nbsp;
        <span>work</span>&nbsp;
        <span>for</span>&nbsp;
        <span>the</span>&nbsp;
        <span>nice</span>&nbsp;
        <span>brands.</span>&nbsp;
        <br />
        <br />
        <span>for</span>&nbsp;
        <span>companies</span>&nbsp;
        <span>that</span>&nbsp;
        <span>CARE.</span>&nbsp;
        <span>care</span>&nbsp;
        <span>for</span>&nbsp;
        <span>what</span>&nbsp;
        <span>they</span>&nbsp;
        <span>make</span>&nbsp;
        <span>and</span>&nbsp;
        <span>how</span>&nbsp;
        <span>they</span>&nbsp;
        <span>make</span>&nbsp;
        <span>it.</span>&nbsp;
      </p>
    </div>
    <div class="section work" id="work" v-if="!showPrivacy">
      <p class="text--big animateUp" v-in-viewport>
        <span>We</span>&nbsp;
        <span>work</span>&nbsp;
        <span>for</span>&nbsp;
        <span>brands</span>&nbsp;
        <span>Big</span>&nbsp;
        <span>or</span>&nbsp;
        <span>small.</span>&nbsp;
      </p>
      <p class="text--big animateUp" v-in-viewport>
        <span>For</span>&nbsp;
        <span>companies</span>&nbsp;
        <span>that</span>&nbsp;
        <span>are</span>&nbsp;
        <span>motivated.</span>&nbsp;
        <br />
        <span>Intrinsically.</span>
        <br />
        <span>Beyond the cash.</span>
        <br />
        <span>To do things better.</span>
        <br />
        <span>Or make things better.</span>
      </p>
    </div>
    <div class="canHolder" v-if="!showPrivacy">
      <img v-in-viewport class="can" src="/can.png" alt="can" />
    </div>
    <div class="section proud" id="proud" v-if="!showPrivacy">
      <p class="text--big animateUp" v-in-viewport>
        <span>We</span>&nbsp;
        <span>are</span>&nbsp;
        <span>very</span>&nbsp;
        <span>proud</span>&nbsp;
        <span>to</span>&nbsp;
        <span>work</span>&nbsp;
        <span>for</span>&nbsp;
        <span>these</span>&nbsp;
        <span>brands.</span>
      </p>
    </div>
    <div class="section brands"  v-if="!showPrivacy">
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon" clipPathUnits="objectBoundingBox">
            <polygon points="0 0, 0.55 0.04, 0.50 0.18, 0.25 0.30, 0 0.20" />
          </clipPath>
        </defs>
      </svg>
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon2" clipPathUnits="objectBoundingBox">
            <polygon points="0.55 .04, 1 0, 1 0.25, 0.75 0.40, 0.45 0.30" />
          </clipPath>
        </defs>
      </svg>
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon3" clipPathUnits="objectBoundingBox">
            <polygon points="0 0.20, 0.25 0.30, 0.49 0.20, 0.60 0.45, 0.25 0.50, 0 0.43" />
          </clipPath>
        </defs>
      </svg>
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon4" clipPathUnits="objectBoundingBox">
            <polygon
              points="0.45 0.30, 0.75 0.40, 1 0.25, 1 0.70, 0.92 0.69, 0.60 0.67, 0.50 0.60"
            />
          </clipPath>
        </defs>
      </svg>
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon5" clipPathUnits="objectBoundingBox">
            <polygon points="0 0.43, 0.25 0.50, 0.60 0.45, 0.98 0.65, 0.50 0.85, 0 0.75" />
          </clipPath>
        </defs>
      </svg>
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon6" clipPathUnits="objectBoundingBox">
            <polygon points="0.50 0.85, 1 0.60, 1 1.20, 0.45 1.12" />
          </clipPath>
        </defs>
      </svg>
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon7" clipPathUnits="objectBoundingBox">
            <polygon points="0 0.75, 0.50 0.85, 0.45 1.12, 0 1.15" />
          </clipPath>
        </defs>
      </svg>
      <svg class="clip-svg">
        <defs>
          <clipPath id="clip-polygon8" clipPathUnits="objectBoundingBox">
            <polygon points="0 0.75, 0.50 0.85, 0.45 1.12, 0 1.15" />
          </clipPath>
        </defs>
      </svg>
      <div class="tonys">
        <div class="logoCarousel"></div>
      </div>
      <div class="primal">
        <div class="logoCarousel"></div>
      </div>
      <div class="rude">
        <div class="logoCarousel"></div>
      </div>
      <div class="nice">
        <div class="logoCarousel"></div>
      </div>
      <div class="nb">
        <div class="logoCarousel"></div>
      </div>
      <div class="justnuts">
        <div class="logoCarousel"></div>
      </div>
      <div class="farm">
        <div class="logoCarousel"></div>
      </div>
      <div class="ella">
        <div class="logoCarousel"></div>
      </div>
      <div class="gulpener">
        <div class="logoCarousel"></div>
      </div>
      <div class="donny">
        <div class="logoCarousel"></div>
      </div>
      <div class="magimix">
        <div class="logoCarousel"></div>
      </div>
      <div class="nairns">
        <div class="logoCarousel"></div>
      </div>
      <div class="olivery">
        <div class="logoCarousel"></div>
      </div>
      <div class="pablo">
        <div class="logoCarousel"></div>
      </div>
      <div class="baleine">
        <div class="logoCarousel"></div>
      </div>
      <div class="delicious">
        <div class="logoCarousel"></div>
      </div>
      <!-- <div class="yaya">
        <div class="logoCarousel"></div>
      </div>-->
    </div>
    <div class="section chat" id="chat" v-if="!showPrivacy">
      <p class="text--big animateUp" v-in-viewport>
        <span>Feel</span>&nbsp;
        <span>like</span>&nbsp;
        <span>a</span>&nbsp;
        <span>chat?</span>
      </p>
      <p
        class="caption animateUp"
        v-in-viewport
      >We have some really nice tea, great cookies and excellent chocolate.</p>
      <a class="btn chat-btn" v-in-viewport href="mailto:info@ka-pow.nl">Let's chat</a>
    </div>
    <div class="section lady"></div>

    <div class="section privacy" id="privacy" v-if="showPrivacy">
      <a class="btn btn--strokeBlack" @click="showPrivacy = false">X Close</a>
      <h1 class="primaryTitle">PRIVACY STATEMENT</h1>
      <div>
        <p>Pow Comms is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.</p>
        <p>
          <strong>Van wie verwerken wij persoonsgegevens?</strong>
          <br />Pow Comms verwerkt je persoonsgegevens als je een zakenrelatie van ons bedrijf bent, je op een vacature bij Pow Comms hebt gesolliciteerd, je in dienst bent bij Pow Comms, je goederen of diensten aan Pow Comms levert, je een offerte of nieuwsbriefabonnement hebt aangevraagd bij Pow Comms of indien je op andere wijze contact hebt gezocht met Pow Comms. Abonnees van de bedrijfspagina’s van Pow Comms op de social mediaplatformen van LinkedIn, Facebook, YouTube, Vimeo, Slack, Google+, Twitter en Instagram beschouwen wij als zakenrelaties evenals connecties die via LinkedIn verbonden zijn aan leden van de directie van Pow Comms.
        </p>
        <p>
          <strong>Persoonsgegevens die wij verwerken</strong>
          <br />Pow Comms verwerkt je persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze gegevens zelf aan ons verstrekt. Hieronder vind je een overzicht van de persoonsgegevens die wij verwerken:
          <ul>
          <li>Bedrijfsnaam</li>
          <li>Afdeling</li>
          <li>Geslacht</li>
          <li>Geboortedatum</li>
          <li>Adresgegevens</li>
          <li>Telefoonnummer</li>
          <li>E-mailadres</li>
          <li>Bankrekeningnummer</li>
          <li>Inschrijvingsnummer Kamer van Koophandel</li>
          <li>BTW-nummer</li>
          <li>Overige persoonsgegevens die je actief verstrekt bijvoorbeeld door een offerte op deze website aan te maken, dienst af te nemen, in correspondentie en/ of telefonisch te vermelden</li>
          <li>Locatiegegevens</li>
          <li>Internetbrowser en apparaat type</li>
          <li>Gegevens over jouw activiteiten op onze website</li>
          </ul>
        </p>
        <p><strong>Bijzondere en/of gevoelige persoonsgegevens die we verwerken</strong><br />
        Onze website en/of dienst heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als je ervan overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via info[at]ka-pow.nl dan verwijderen wij deze informatie.
       </p>
        <p><strong>Met welk doel en op basis van welke grondslag we persoonsgegevens verwerken</strong><br/>
        Pow Comms verwerkt jouw persoonsgegevens voor de volgende doelen:<br/>
        Het in behandeling nemen van informatieverzoeken, offerte-aanvragen en opdrachten. Je te kunnen bellen of e-mailen indien dit nodig is om onze dienstverlening uit te kunnen voeren.
        Je te informeren over wijzigingen van onze diensten en producten.
        Om goederen en diensten bij je af te leveren.
        Om je te informeren middels nieuwsbrieven en/of andere gegevensdragers of media over actuele ontwikkelingen in ons vakgebied of binnen ons bedrijf.
        Pow Comms analyseert jouw gedrag op de website om daarmee de website te verbeteren en het aanbod aan producten en diensten af te stemmen op jouw voorkeuren.
        Pow Comms verwerkt ook persoonsgegevens als wij hier wettelijk toe verplicht zijn, zoals gegevens die wij nodig hebben voor onze belastingaangifte.</p>
        <p><strong>Geautomatiseerde besluitvorming</strong><br/>
        Pow Comms neemt op basis van geautomatiseerde verwerkingen geen besluiten over zaken die (aanzienlijke) gevolgen kunnen hebben voor personen. Het gaat hier om besluiten die worden genomen door computerprogramma’s of -systemen, zonder dat daar een mens (bijvoorbeeld een medewerker van Pow Comms) tussen zit.
        </p>
        <p><strong>Bewaartermijn</strong><br/>
        Pow Comms bewaart je persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor je gegevens worden verzameld. Wij hanteren de volgende bewaartermijnen voor de volgende (categorieën) van persoonsgegevens:
        Klanten > Bewaartermijn > 5 Jaar, Dit in verband met de bewaarplicht met betrekking tot de belastingaangifte.
        Leads > Bewaartermijn > 3 Jaar, Dit in verband met sales-gerelateerde activiteiten.
        Leveranciers > Bewaartermijn > 5 Jaar, Dit in verband met de bewaarplicht met betrekking tot de belastingaangifte.</p>
        <p><strong>Delen van persoonsgegevens met derden</strong><br/>
        Pow Comms verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met jou of om te voldoen aan een wettelijke verplichting.</p>
        <p><strong>Cookies, of vergelijkbare technieken, die wij gebruiken</strong><br/>
        Pow Comms gebruikt geen cookies. Cookies zijn om op te eten.</p>
        <p> <strong>Gegevens inzien, aanpassen of verwijderen</strong><br/>
        Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te verwijderen. Dit kun je doen door contact met ons op te nemen. Daarnaast heb je het recht om je eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van jouw persoonsgegevens door ons bedrijf en heb je het recht op gegevensoverdraagbaarheid. Dat betekent dat je bij ons een verzoek kan indienen om de persoonsgegevens die wij van jou beschikken in een computerbestand naar jou of een ander, door jou genoemde organisatie, te sturen. Wil je gebruik maken van je recht op bezwaar en/of recht op gegevensoverdraagbaarheid of heb je andere vragen/opmerkingen over de gegevensverwerking, stuur dan een gespecificeerd verzoek naar info[at]ka-pow.nl. Om er zeker van te zijn dat het verzoek tot inzage door jou is gedaan, vragen wij jou een kopie van je identiteitsbewijs bij het verzoek mee te sturen. Maak in deze kopie je pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van je privacy. Pow Comms zal zo snel mogelijk, maar in ieder geval binnen vier weken, op jouw verzoek reageren. Pow Comms wil je er tevens op wijzen dat je de mogelijkheid hebt om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens.
        </p>
        <p><strong>Hoe wij persoonsgegevens beveiligen</strong><br/>
        Pow Comms neemt de bescherming van jouw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als jij het idee hebt dat jouw gegevens toch niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op via info[at]ka-pow.nl of bel met 06 288 388 86
      </p>
        
        
       </div>
    </div>

    <div class="footer">
      <a class="btn btn--stroke" href="https://www.linkedin.com/company/powcomms" target="_blank">
        We're on
        <img src="linkedin.png" width="25" alt class="btn__icon" />
      </a>
      <a class="btn btn--stroke" href="https://www.instagram.com/powcomms" target="_blank">
        We're on
        <img src="instagram.png" width="25" alt class="btn__icon" />
      </a>
      <p>
        Or just send us an
        <a class="arrow" href="mailto:info@ka-pow.nl">email</a>
      </p>
      <p>
        Or call
        <a class="arrow" href="tel:0628838886">06 28 83 88 86</a>
      </p>
      <p>
        Or visit us at
        <strong class="arrow">
          <br />Timorplein 31
          <br />1094 CC Amsterdam
        </strong>
      </p>
      <div class="footer__links">
        <a @click="showPrivacy = true" v-scroll-to="'#privacy'">Privacy Policy</a>
      </div>
    </div>
    <div class="copyright">&copy; 2020 Pow Comms</div>
    <cookie-law theme="dark-lime"></cookie-law>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
export default {
  components: { CookieLaw },
  data() {
    return {
      menuOpen: false,
      showPrivacy: false
    };
  }
};
</script>

<style lang="scss">
@import "./scss/style.scss";
</style>
